(function () {
  'use strict';

  var selectors = {
    toggle: '[data-bulk-toggle]',
    bar: '[data-bulk-bar]',
    count: '[data-bulk-count]',
    list: '[data-bulk-list]',
    variantSelect: '[data-bulk-variant]',
    addButton: '[data-bulk-add]',
    clearButton: '[data-bulk-clear]',
    status: '[data-bulk-status]'
  };

  var STORAGE_KEY = 'pp-bulk-add';

  var state = {
    items: new Map(), // handle -> { handle, title, variants: [{id,title}], button }
    lastAction: null,
    hasInteracted: false,
    allowAutoShow: false
  };

  var els = {};

  function getThemeString(key, fallback) {
    if (window.theme && theme.strings && theme.strings[key]) {
      return theme.strings[key];
    }
    return fallback;
  }

  function init() {
    if (typeof document === 'undefined') return;
    state.allowAutoShow = isCollectionPage();
    state.hasInteracted = state.allowAutoShow;
    cacheDom();
    loadFromStorage();
    syncDomSelections();
    bindEvents();
    updateUI();
  }

  function cacheDom() {
    els.bar = document.querySelector(selectors.bar);
    els.count = document.querySelector(selectors.count);
    els.list = document.querySelector(selectors.list);
    els.variantSelect = document.querySelector(selectors.variantSelect);
    els.addButton = document.querySelector(selectors.addButton);
    els.clearButton = document.querySelector(selectors.clearButton);
    els.status = document.querySelector(selectors.status);
  }

  function bindEvents() {
    document.addEventListener('click', handleClick);
    if (els.variantSelect) {
      els.variantSelect.addEventListener('change', handleVariantChange);
    }
    document.addEventListener('theme:ajax-products-reloaded', function () {
      // When grid re-renders, re-apply selection states without clearing saved items
      syncDomSelections();
      updateUI();
    });
  }

  function handleClick(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var toggle = target.closest(selectors.toggle);
    if (toggle) {
      event.preventDefault();
      toggleSelection(toggle);
      return;
    }

    var chipRemove = target.closest('[data-bulk-remove]');
    if (chipRemove) {
      event.preventDefault();
      removeByHandle(chipRemove.getAttribute('data-bulk-remove'));
      return;
    }

    if (els.clearButton && target.closest(selectors.clearButton)) {
      event.preventDefault();
      clearAll();
      return;
    }

    if (els.addButton && target.closest(selectors.addButton) && !els.addButton.disabled) {
      event.preventDefault();
      bulkAddToCart();
    }
  }

  function toggleSelection(button) {
    var handle = button.getAttribute('data-product-handle');
    var title = button.getAttribute('data-product-title') || 'Product';
    state.hasInteracted = true;
    if (!handle) return;
    if (state.items.has(handle)) {
      removeByHandle(handle);
      return;
    }
    var variants = parseVariants(button);
    state.items.set(handle, {
      handle: handle,
      title: title,
      variants: variants,
      button: button
    });
    state.lastAction = 'add';
    debug('Selected', handle, variants);
    trackEvent('bulk_select_toggle', {
      handle: handle,
      title: title,
      variants: variants.map(function (v) { return v.title; })
    });
    button.classList.add('is-selected');
    button.setAttribute('aria-pressed', 'true');
    updateUI();
  }

  function parseVariants(button) {
    var card = button.closest('.product-block');
    if (!card) return [];
    var script = card.querySelector('.bulk-add-variant-data');
    if (!script) {
      return fallbackVariant(button);
    }
    try {
      var parsed = JSON.parse(script.textContent || '[]');
      var variants = (parsed || []).map(function (variant) {
        return { id: variant.id, title: variant.title };
      }).filter(function (variant) {
        return variant.id && variant.title;
      });
      if (variants.length === 0) {
        return fallbackVariant(button);
      }
      return variants;
    } catch (error) {
      return fallbackVariant(button);
    }
  }

  function fallbackVariant(button) {
    var id = button.getAttribute('data-bulk-first-variant-id');
    var title = button.getAttribute('data-bulk-first-variant-title');
    if (id && title) {
      return [{ id: parseInt(id, 10), title: title }];
    }
    return [];
  }

  function removeByHandle(handle) {
    if (!state.items.has(handle)) return;
    var item = state.items.get(handle);
    if (item.button) {
      item.button.classList.remove('is-selected');
      item.button.setAttribute('aria-pressed', 'false');
    } else {
      var buttons = document.querySelectorAll(selectors.toggle + '[data-product-handle="' + handle + '"]');
      buttons.forEach(function (btn) {
        btn.classList.remove('is-selected');
        btn.setAttribute('aria-pressed', 'false');
      });
    }
    state.items.delete(handle);
    state.lastAction = 'remove';
    updateUI();
  }

  function clearAll() {
    state.items.forEach(function (item) {
      if (item.button) {
        item.button.classList.remove('is-selected');
        item.button.setAttribute('aria-pressed', 'false');
      }
    });
    state.items.clear();
    state.lastAction = 'clear';
    updateUI();
  }

  function renderChips() {
    if (!els.list) return;
    var wasAnimating = els.list.classList.contains('is-adding');
    els.list.innerHTML = '';
    // Build array to allow reversing for newest-first display
    var chips = [];
    state.items.forEach(function (item) {
      var chip = document.createElement('span');
      chip.className = 'bulk-add-chip';
      chip.textContent = item.title;
      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'bulk-add-chip__remove';
      removeBtn.setAttribute('data-bulk-remove', item.handle);
      removeBtn.setAttribute('aria-label', 'Remove ' + item.title);
      removeBtn.textContent = '×';
      chip.appendChild(removeBtn);
      chips.push(chip);
    });
    // Newest items (last added) should appear first
    chips.reverse().forEach(function (chip, idx) {
      if (state.lastAction === 'add' && idx === 0) {
        chip.classList.add('is-new');
      }
      els.list.appendChild(chip);
    });
    // Scroll to start so the newest chip is visible
    els.list.scrollTo({ left: 0, behavior: 'smooth' });
    if (state.lastAction === 'add') {
      // Trigger a quick nudge animation
      els.list.classList.remove('is-adding');
      // force reflow to restart animation
      void els.list.offsetWidth;
      els.list.classList.add('is-adding');
      setTimeout(function () {
        els.list.classList.remove('is-adding');
      }, 320);
    } else if (!wasAnimating) {
      els.list.classList.remove('is-adding');
    }
    state.lastAction = null;
  }

  function buildVariantOptions() {
    if (!els.variantSelect) return;
    var titles = [];
    state.items.forEach(function (item) {
      item.variants.forEach(function (variant) {
        var normalized = normalize(variant.title);
        if (titles.indexOf(normalized) === -1) {
          titles.push(normalized);
        }
      });
    });
    // If any item is single-variant, ensure that variant is included
    if (titles.length === 0) {
      var single = firstAvailableVariantTitle();
      if (single) titles.push(normalize(single));
    }
    var options = titles.map(function (normalized) {
      return findOriginalTitle(normalized) || normalized;
    });
    if (options.length === 0) {
      var fallback = firstAvailableVariantTitle();
      if (fallback) {
        options = [fallback];
      }
    }

    var previous = els.variantSelect.value;
    els.variantSelect.innerHTML = '';
    options.forEach(function (title) {
      var opt = document.createElement('option');
      opt.value = title;
      opt.textContent = title;
      els.variantSelect.appendChild(opt);
    });

    if (options.length === 0) {
      els.variantSelect.disabled = true;
    } else {
      els.variantSelect.disabled = false;
      if (previous && options.indexOf(previous) > -1) {
        els.variantSelect.value = previous;
      } else {
        els.variantSelect.value = options[0];
      }
    }
  }

  function normalize(text) {
    return (text || '').trim().toLowerCase();
  }

  function findOriginalTitle(normalized) {
    var found = null;
    state.items.forEach(function (item) {
      if (found) return;
      item.variants.forEach(function (variant) {
        if (normalize(variant.title) === normalized) {
          found = variant.title;
        }
      });
    });
    return found || normalized;
  }

  function firstAvailableVariantTitle() {
    var first = null;
    state.items.forEach(function (item) {
      if (first) return;
      if (item.variants && item.variants.length) {
        first = item.variants[0].title;
      }
    });
    return first;
  }

  function handleVariantChange() {
    updateStatus('');
    toggleAddButton();
  }

  function toggleAddButton() {
    if (!els.addButton) return;
    var disabled = state.items.size === 0 || !els.variantSelect || !els.variantSelect.value;
    els.addButton.disabled = disabled;
    var base = getThemeString('bulk_add_add_to_cart', 'Add to cart');
    var withCount = getThemeString('bulk_add_add_to_cart_with_count', 'Add to cart ([COUNT])');
    if (!disabled) {
      var count = state.items.size;
      els.addButton.textContent = withCount.replace('[COUNT]', count);
    } else {
      els.addButton.textContent = base;
    }
  }

  function updateUI() {
    if (!els.bar) return;
    var hasItems = state.items.size > 0;
    var canShow = state.hasInteracted || state.allowAutoShow;
    var shouldShow = hasItems && canShow;
    els.bar.classList.toggle('is-visible', shouldShow);
    els.bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    if (els.count) {
      els.count.textContent = state.items.size;
    }
    renderChips();
    buildVariantOptions();
    toggleAddButton();
    if (!hasItems) {
      updateStatus('');
    }
    persistState();
  }

  function bulkAddToCart() {
    if (!els.variantSelect) return;
    var variantTitle = els.variantSelect.value;
    var selectedItems = [];
    var missing = [];
    state.items.forEach(function (item) {
      var match = item.variants.find(function (variant) {
        return normalize(variant.title) === normalize(variantTitle);
      });
      if (match) {
        selectedItems.push({ id: match.id, quantity: 1 });
      } else {
        missing.push(item.title);
      }
    });

    if (!selectedItems.length) {
      updateStatus(getThemeString('bulk_add_variant_unavailable', 'Variant not available for selected items.'));
      return;
    }

    setLoading(true);
    var payload = { items: selectedItems };
    debug('Adding items', payload);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) throw new Error('Add to cart failed');
      return response.json();
    }).then(function () {
      var addedTemplate = getThemeString('bulk_add_added', 'Added [COUNT] items to cart.');
      var skippedTemplate = getThemeString('bulk_add_added_skipped', 'Added [COUNT] items. Skipped: [SKIPPED]');
      var note = missing.length
        ? skippedTemplate.replace('[COUNT]', selectedItems.length).replace('[SKIPPED]', missing.join(', '))
        : addedTemplate.replace('[COUNT]', selectedItems.length);
      trackEvent('bulk_add_to_cart', {
        count_added: selectedItems.length,
        variant_title: variantTitle,
        handles: Array.from(state.items.keys())
      });
      clearAll();
      updateStatus(note);
      document.documentElement.dispatchEvent(
        new CustomEvent('theme:cartchanged', { bubbles: true, cancelable: false, detail: { openDrawer: true } })
      );
      setTimeout(function () {
        if (els.bar) {
          els.bar.classList.remove('is-visible');
          els.bar.setAttribute('aria-hidden', 'true');
        }
      }, 150);
    }).catch(function (error) {
      updateStatus(getThemeString('bulk_add_add_failed', 'Could not add items. Please try again.'));
      debug('Add failed', error);
    }).finally(function () {
      setLoading(false);
    });
  }

  function setLoading(isLoading) {
    if (!els.addButton) return;
    els.addButton.disabled = isLoading;
    if (isLoading) {
      els.addButton.textContent = getThemeString('bulk_add_adding', 'Adding...');
    } else {
      toggleAddButton();
    }
  }

  function updateStatus(message) {
    if (!els.status) return;
    els.status.textContent = message || '';
  }

  function debug() {
    if (!window.bulkAddDebug || !window.console) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[bulk-add]');
    console.log.apply(console, args);
  }

  function isCollectionPage() {
    if (!document || !document.body) return false;
    var classes = document.body.classList;
    return classes.contains('template-collection') || classes.contains('collection');
  }

  function persistState() {
    if (!canStore()) return;
    var payload = [];
    state.items.forEach(function (item) {
      payload.push({
        handle: item.handle,
        title: item.title,
        variants: item.variants
      });
    });
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    } catch (e) {
      debug('Persist failed', e);
    }
  }

  function loadFromStorage() {
    if (!canStore()) return;
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return;
      parsed.forEach(function (item) {
        if (!item || !item.handle) return;
        state.items.set(item.handle, {
          handle: item.handle,
          title: item.title || getThemeString('bulk_add_product_fallback', 'Product'),
          variants: Array.isArray(item.variants) ? item.variants : [],
          button: null
        });
      });
    } catch (e) {
      debug('Load failed', e);
    }
  }

  function syncDomSelections() {
    var toggles = document.querySelectorAll(selectors.toggle);
    toggles.forEach(function (button) {
      var handle = button.getAttribute('data-product-handle');
      var isSelected = handle && state.items.has(handle);
      button.classList.toggle('is-selected', !!isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      if (isSelected) {
        var item = state.items.get(handle);
        if (item) item.button = button;
      }
    });
  }

  function canStore() {
    try {
      var testKey = '__pp_bulk_test__';
      localStorage.setItem(testKey, '1');
      localStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  function trackEvent(name, data) {
    try {
      if (window.dataLayer && Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: name }, data || {}));
      } else if (window.gtag) {
        window.gtag('event', name, data || {});
      }
    } catch (e) {
      debug('trackEvent failed', e);
    }
  }

  document.addEventListener('DOMContentLoaded', init);
})();
